module.exports = __webpack_public_path__ + "img/office_1.70c1b4c6.jpeg";